import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const pct = (n) => `${n}%`;

export default function TrainingResult() {
  const [rows, setRows] = useState([]);
  const [detail, setDetail] = useState(null);
  const [selMistake, setSelMistake] = useState(null);

  useEffect(() => { api.get("/results").then((r) => setRows(r.data)).catch(() => {}); }, []);

  const openDetail = async (sid) => {
    const { data } = await api.get(`/results/${sid}`);
    setDetail(data);
  };

  return (
    <div data-testid="training-result-page">
      <div className="section-head">Training Result</div>
      <table className="panel-table" data-testid="result-table">
        <thead>
          <tr>
            <th>Staff</th><th>Duration</th><th>Total Form</th><th>Processed</th><th>Pending</th>
            <th>Correct</th><th>Wrong</th><th>Critical</th><th>Accuracy</th><th>Avg Time</th><th>Score</th><th>Result</th><th></th>
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 && <tr className="empty-row"><td colSpan={13}>Belum ada hasil training</td></tr>}
          {rows.map((r) => (
            <tr key={r.session_id} data-testid={`result-row-${r.session_id}`}>
              <td>{r.staff}</td>
              <td>{r.duration || "-"}</td>
              <td>{r.total_form}</td>
              <td>{r.processed}</td>
              <td>{r.pending_transactions}</td>
              <td>{r.correct_action}</td>
              <td>{r.mistake}</td>
              <td>{r.critical_mistake}</td>
              <td>{pct(r.accuracy)}</td>
              <td>{r.average_processing_time}s</td>
              <td>{r.final_score}</td>
              <td><span className={`badge ${r.passed ? "badge-pass" : "badge-fail"}`}>{r.passed ? "PASS" : "FAIL"}</span></td>
              <td><a className="link-blue" onClick={() => openDetail(r.session_id)} data-testid={`view-detail-${r.session_id}`}>Detail</a></td>
            </tr>
          ))}
        </tbody>
      </table>

      <Dialog open={!!detail} onOpenChange={(o) => { if (!o) { setDetail(null); setSelMistake(null); } }}>
        <DialogContent className="max-w-4xl max-h-[85vh] overflow-auto">
          <DialogHeader><DialogTitle>Detail Training — {detail?.session?.staff_name}</DialogTitle></DialogHeader>
          {detail && (
            <div style={{ fontSize: 12 }}>
              <div className="section-head">Mistakes ({detail.mistakes.length})</div>
              <table className="panel-table" data-testid="mistakes-table">
                <thead>
                  <tr><th>Transaction ID</th><th>Type</th><th>User</th><th>Amount</th><th>Staff Action</th><th>Expected</th><th>Mistake Type</th><th>Critical</th><th></th></tr>
                </thead>
                <tbody>
                  {detail.mistakes.length === 0 && <tr className="empty-row"><td colSpan={9}>Tidak ada mistake</td></tr>}
                  {detail.mistakes.map((m) => (
                    <tr key={m.id}>
                      <td>{m.transaction_id}</td>
                      <td>{m.type}</td>
                      <td>{m.user}</td>
                      <td className="text-right">{Number(m.amount).toLocaleString("en-US")}</td>
                      <td>{m.staff_action}</td>
                      <td>{m.expected_action}</td>
                      <td>{m.mistake_type || "-"}</td>
                      <td>{m.is_critical ? <span className="badge badge-critical">YES</span> : "no"}</td>
                      <td><a className="link-blue" onClick={() => setSelMistake(m)}>Lihat</a></td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {selMistake && (
                <div style={{ marginTop: 12, border: "1px solid #ddd", padding: 12 }} data-testid="mistake-detail">
                  <div className="section-head">Form {selMistake.transaction_id}</div>
                  <div className="report-grid" style={{ maxWidth: 600 }}>
                    <div className="rk">Data Mutasi</div><div style={{ whiteSpace: "pre-line" }}>{selMistake.info}</div>
                    <div className="rk">Bank</div><div>{selMistake.bank}</div>
                    <div className="rk">Keputusan Staff</div><div>{selMistake.staff_action}</div>
                    <div className="rk">Keputusan Seharusnya</div><div>{selMistake.expected_action}</div>
                    <div className="rk">Alasan Mistake</div><div>{selMistake.mistake_type || "-"}</div>
                    <div className="rk">Jam Form Masuk</div><div>{selMistake.appeared_at ? new Date(selMistake.appeared_at).toLocaleString("sv-SE").replace("T", " ") : "-"}</div>
                    <div className="rk">Jam Staff Proses</div><div>{selMistake.processed_at ? new Date(selMistake.processed_at).toLocaleString("sv-SE").replace("T", " ") : "-"}</div>
                    <div className="rk">Processing Time</div><div>{selMistake.processing_time}s</div>
                  </div>
                </div>
              )}
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
